module.exports = __webpack_public_path__ + "img/Doc.53c915fc.svg";